export default "__VITE_ASSET__CKIu7pE___"